import React from 'react';

const NotFound = () => {
    return (
        <div className='text-center pb-5 pt-5'>
            <h1>Page Not Found</h1>
            <p>Don't ask me about this page.</p>
        </div>
    );
};

export default NotFound;